import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileCirclePlus } from '@/icons';
import './IconAddItemsButton.css';

interface IconAddItemsButtonProps {
  onClick: () => void;
  title?: string;
  disabled?: boolean;
  className?: string;
}

const IconAddItemsButton: React.FC<IconAddItemsButtonProps> = ({
  onClick,
  title,
  disabled = false,
  className = '',
}) => {
  return (
    <button
      className={`icon-add-items-button ${className}`}
      onClick={onClick}
      title={title}
      disabled={disabled}
    >
      <FontAwesomeIcon icon={faFileCirclePlus} />
    </button>
  );
};

export default IconAddItemsButton;
